module.exports = __webpack_public_path__ + "img/Oman_mobile_icon.c6eef204.svg";